/**
 * gamesis Story API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Character { 
    id: string;
    name: string;
    initials?: string;
    players?: Set<string>;
    inactive?: boolean;
    description?: string;
    readonly avatar?: string;
    playingCharacter?: boolean;
}

